export default "/images/vendor/flag-icon-css/flags/1x1/mo.svg?8d4848888f2e8b82554594097cb5c21b";